import { http, createConfig } from "wagmi";
import { type Chain } from "viem";
import { getDefaultConfig } from "@rainbow-me/rainbowkit";

export const jasmyChain: Chain = {
  id: 680,
  name: "JasmyChain",
  nativeCurrency: {
    name: "JASMY",
    symbol: "JASMY",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: [import.meta.env.VITE_RPC_URL || "https://rpc.jasmyscan.net"],
    },
  },
  blockExplorers: {
    default: {
      name: "JasmyScan",
      url: "https://explorer.jasmyscan.net",
    },
  },
};

export const config = getDefaultConfig({
  appName: "Jasmy Swap",
  projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || "demo",
  chains: [jasmyChain],
  transports: {
    [jasmyChain.id]: http(
      import.meta.env.VITE_RPC_URL || "https://rpc.jasmyscan.net"
    ),
  },
});

export { createConfig, http };
